<script setup>
import { Tooltip } from 'flowbite-vue'
import { useUserStore } from '@/stores/UserStore'
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import { Icon } from '@iconify/vue'

const userStore = useUserStore()

const handleTooltipHover = () => {
  userStore.fetchInprogressJobs()
}

</script>
<template>
  <Tooltip
    placement="bottom-end"
    theme="light"
    :trigger="'click'"
  >
    <template #trigger>
      <div 
        @click="handleTooltipHover"
        class="relative cursor-pointer w-8 h-8 bg-blue-600 rounded flex items-center justify-center"
      >
        <Icon icon="heroicons:arrow-path" class="text-2xl text-white" />
        <div v-if="userStore.inprogressJobsLength" class="absolute bottom-1 right-1 w-3 h-3 bg-red-500 rounded-full flex items-center justify-center">
          <span class="text-[10px] font-semibold text-white">{{ userStore.inprogressJobsLength }}</span>
        </div>
      </div>
    </template>
    <template #content>
      <div class="base-tooltip-light flex flex-col gap-y-2 rounded-lg p-2 max-h-[500px] overflow-y-auto w-[300px] border border-gray-200">
        <div v-if="userStore.inprogressJobsLoading" class="flex justify-center items-center h-full">
          <LoadingSpinner :background="'bg-gray-100'" :width="'48px'" :height="'48px'" />
        </div>
        <div v-else v-for="job in userStore.preparedInprogressJobs" :key="job.id" class="flex gap-3 border-b border-gray-200 pb-2 last:border-b-0 last:pb-0 w-full flex-col">
          <div class="flex items-center gap-x-3 ">
            <div class="w-9 h-9">
              <img v-if="job.channel" :src="job.channel.logo" class="w-9 h-9 object-contain" />
            </div>
            
            <div class="flex flex-col gap-y-1 w-full">
              <div class="flex justify-between w-full">
                <span v-if="job.channel" class="text-xs text-gray-900 font-semibold">{{ job.channel.name }}</span>
                <!-- <Icon icon="heroicons:x-mark" class="text-base ml-auto" /> -->
              </div>
              <span class="text-xs font-normal text-gray-600">{{ job.message }} </span>
            </div>
          </div>
          <div class="flex gap-4 items-center">
            <div class="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
                <div
                  class="h-full rounded-full bg-tint-1 transition-all duration-300"
                  :style="{ width: (job.progress || 0) + '%' }"
                ></div>
              </div>
              <span class="min-w-[40px] text-tint-1 font-medium text-xs text-right">{{ (job.progress || 0) }}%</span>
          </div>
          <!-- <div class="flex items-center gap-x-1 justify-between w-full">
            <div class="flex items-center gap-x-1 text-xs py-[6px] px-2 rounded-md bg-pink-100">
              <Icon icon="heroicons:exclamation-circle" class="text-base text-pink-900" />
              <span class="text-xs text-pink-900">Failed with errors</span>
            </div>
            <span class="text-xs text-tint-1 hover:underline cursor-pointer">See Details </span>
          </div> -->
          <!-- <div class="flex items-center gap-x-1 text-xs py-[6px] px-2 rounded-md bg-green-100 w-fit">
            <Icon icon="heroicons:check-circle" class="text-base text-green-900" />
            <span class="text-xs text-green-900">Completed</span>
          </div> -->
          <!-- <span class="text-xs text-gray-600">{{ job.message }} </span> -->
        </div>
      </div>
    </template>
  </Tooltip>
</template>
<style scoped>
@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.animate-pulse {
  animation: pulse 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>